import { LiveAnnouncer } from '@angular/cdk/a11y';
import { COMMA, ENTER } from '@angular/cdk/keycodes';
import { Component, ElementRef, inject, Input, OnChanges, OnInit, signal, SimpleChanges, ViewChild } from '@angular/core';
import { MatChipEditedEvent, MatChipInputEvent } from '@angular/material/chips';
import { NG_VALUE_ACCESSOR } from '@angular/forms';
import { ValueAccessorBase } from '../shared/value-accessor/value-accessor-base';

@Component({
    selector: 'sem-tags-input',
    templateUrl: './sem-tags-input.component.html',
    styleUrls: ['./sem-tags-input.component.css'],
    providers: [
        { provide: NG_VALUE_ACCESSOR, useExisting: SemTagsInputComponent, multi: true }
    ],
    standalone: false
})
export class SemTagsInputComponent extends ValueAccessorBase<string> implements OnInit {
  readonly addOnBlur = true;
  readonly separatorKeysCodes = [ENTER, COMMA] as const;
  //readonly keywords = signal<any[]>([]);
  readonly announcer = inject(LiveAnnouncer);

  get keywords() {
    if (this.value) {
      return this.value.split(",");
    }
    return [];
  }

  // Same lock sources as sem-text-box: control-level readonly (isReadOnly /
  // readOnlyCondition / m2o rules via checkForDisabled) or a read-only form.
  get isLocked(): boolean {
    return this.checkForDisabled(this.getAttribute('name')) == true
      || this.dfms?.isFormReadOnly == true;
  }

  keywordsToString(ka: string[]) {
    return ka.join();
  }

  ngOnInit(): void {
    super.ngOnInit();
  }

  add(event: MatChipInputEvent): void {
    const value = (event.value || '').trim();


    if (value) {
      var newVal: any = [...this.keywords, value];
      newVal = this.keywordsToString(newVal);

      this.value = newVal;
      this.checkAfterInput(newVal);
    }

    // Clear the input value
    event.chipInput!.clear();
  }

  remove(keyword: string): void {
    const index = this.keywords.findIndex(k => k == keyword);

    if (index == undefined || index == null || index < 0) {
      return;
    }

    var keywordsCopy = [...this.keywords];
    keywordsCopy.splice(index, 1);

    var val = this.keywordsToString(keywordsCopy);
    this.value = val;
    this.checkAfterInput(val);

    this.announcer.announce(`Removed ${keyword}`);

    return;
  }

  edit(keyword: string, event: MatChipEditedEvent) {
    const value = event.value.trim();

    if (!value) {
      this.remove(keyword);

      return;
    }

    const index = this.keywords.findIndex(k => k == keyword);

    if (index == undefined || index == null || index < 0) {
      return;
    }

    var newVal: any = [...this.keywords];
    newVal[index] = value;
    newVal = this.keywordsToString(newVal);

    this.value = newVal;
    this.checkAfterInput(newVal);
  }

  checkAfterInput(value) {
    console.log("after input")
    let attName = this.getAttribute("name");

    let control = this.dfms.globalForm.controls[attName];

    if (control !== null && typeof control !== "undefined") {
      this.dfms.globalForm.controls[attName].setValue(value);
      this.dfms.globalForm.controls[attName].updateValueAndValidity();
    }


    this.dfms.updateControlsValidationArray(attName, value);

    if (typeof this.onValueChangeEval != "undefined" && this.onValueChangeEval) {
      eval(this.onValueChangeEval);
    }
  }
}
